var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD28SocialNaver = function SvgD28SocialNaver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFEFF3",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85 6.3a.533.533 0 0 0-.382.163.522.522 0 0 0-.168.387v14.3c0 .149.056.278.168.387a.53.53 0 0 0 .382.163h14.3c.143 0 .27-.054.382-.163a.522.522 0 0 0 .168-.387V6.85a.522.522 0 0 0-.168-.387.533.533 0 0 0-.382-.163H6.85zm2.896 3.85h2.965L15.289 14v-3.85h2.965v7.7h-2.965L12.711 14v3.85H9.746v-7.7z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};
export default SvgD28SocialNaver;